import Container from 'components/Container'
import { SkeletonFormItem, SkeletonItem } from 'components/Skeleton'

const WalletSkeleton = () => (
	<Container space="md" spaceDirection="vertical" margin={{ bottom: 'md' }}>
		<SkeletonFormItem />
		<SkeletonFormItem />
		<SkeletonItem $width={100} $size="large" />
	</Container>
)

export default WalletSkeleton
